import Routes from 'shared/enums/routes';
import Permission from 'shared/features/auth/authorization/enums/permission';

type RoutePermissions = {
  [route: string]: {
    permissionConfig?: 'some' | 'every';
    permissions: Permission[];
  };
};

// The order of this map is important.
// Because the root route will be determined from top to bottom depending on the user's permission
// Meaning that the route: '/' will automatically go to '/organisation' and '/residentsettings' is the second option, etc.
// PermissionConfig will determine if the user needs every permission or some permission inside the array
const RoutePermissions: RoutePermissions = {
  [Routes.Organisation]: {
    permissionConfig: 'some',
    permissions: [Permission.ReadOrganisationUnit, Permission.CreateOrganisationUnit],
  },
  [Routes.Residents]: {
    permissionConfig: 'some',
    permissions: [Permission.ReadResidentsSettings, Permission.ReadResidentsChangeLog],
  },
  [Routes.ResidentsSettings]: {
    permissions: [Permission.ReadResidentsSettings],
  },
  [Routes.ResidentsChangeLog]: {
    permissions: [Permission.ReadResidentsChangeLog],
  },
  [Routes.History]: {
    permissions: [Permission.ReadHistory],
  },
  [Routes.FaultsHistory]: {
    permissions: [Permission.ReadAlertsHistory],
  },
  [Routes.Integrations]: {
    permissionConfig: 'some',
    permissions: [Permission.ReadDevice, Permission.ReadSystems, Permission.ReadGateways, Permission.ReadConnectors],
  },
  [Routes.IntegrationsDevices]: {
    permissions: [Permission.ReadDevice],
  },
  [Routes.IntegrationsSystems]: {
    permissions: [Permission.ReadSystems],
  },
  [Routes.IntegrationsGateways]: {
    permissions: [Permission.ReadGateways],
  },
  [Routes.IntegrationsConnectors]: {
    permissions: [Permission.ReadConnectors],
  },
  [Routes.Roles]: {
    permissionConfig: 'some',
    permissions: [Permission.ReadRole, Permission.CreateRole],
  },
  [Routes.Dashboard]: {
    permissions: [Permission.InsightsPortalAccess],
  },
  [Routes.Tenants]: {
    permissions: [Permission.ReadTenant],
  },
  [Routes.FeatureSubscriptions]: {
    permissions: [Permission.ReadTenant],
  },
  [Routes.TemporaryAccess]: {
    permissions: [Permission.ManageTemporaryAccess],
  },
  [Routes.Settings]: {
    permissionConfig: 'some',
    permissions: [
      Permission.SettingsExplanationLink,
      Permission.SettingsEmergencyAlarm,
      Permission.CareConnectReadAndUpdateSettings,
      Permission.SettingsWanderingBoundaries,
      Permission.SettingsMalfunctionNotifications,
      Permission.UpdateTenant,
      Permission.ReadTenant,
    ],
  },
  [Routes.SettingsExplanationLink]: {
    permissions: [Permission.SettingsExplanationLink],
  },
  [Routes.SettingsEmergencyAlarm]: {
    permissions: [Permission.SettingsEmergencyAlarm],
  },
  [Routes.SettingsCareConnect]: {
    permissions: [Permission.CareConnectReadAndUpdateSettings],
  },
  [Routes.SettingsWanderingBoundaries]: {
    permissions: [Permission.SettingsWanderingBoundaries],
  },
  [Routes.SettingsMalfunctionNotifications]: {
    permissions: [Permission.SettingsMalfunctionNotifications],
  },
  [Routes.SettingsMediaserverSwitch]: {
    permissionConfig: 'some',
    permissions: [Permission.UpdateTenant, Permission.ReadTenant],
  },
};

export default RoutePermissions;
